/**
 * Stable SKU identity for NerdWallet Advisors Match clickouts from ria-client.
 * ponytail: O(1) hard-coded product id until DataOps supplies marketplace entity UUID —
 * then swap productId and delete this note.
 */
export const ADVISORS_MATCH_SKU = {
  productId: 'nerdwallet_advisors_match',
  productName: 'NerdWallet Advisors Match',
  skuName: 'NerdWallet Advisors Match',
  skuSource: 'marketplace' as const,
  skuLevel: 'product' as const,
  skuProductType: 'financial_advisors',
  monetizable: 'yes_assumed' as const,
};
